<template>
    <v-container class="container">
        <v-expansion-panels
            v-model="panel"
            class="expansion-panel"
        >
            <v-expansion-panel>
                <v-expansion-panel-header class="card-title mt-1">
                    <div>
                        Στατιστικά
                        <v-icon :color="theming.cardsAndTablesText || 'black'" class="px-4" @click.stop="togglePanel()" large>
                            mdi-tune
                        </v-icon>
                    </div>
                </v-expansion-panel-header>
                <v-divider/>
                <v-expansion-panel-content>
                    <div class="filters">
                        <v-select
                            v-model="filter.clientId"
                            :items="clients"
                            item-value="id"
                            item-text="name"
                            label="Πελάτης"
                            clearable
                            outlined
                            class="filter-field client"
                            @change="onClientSelect"
                        ></v-select>
                        <v-select
                            v-model="filter.contractorId"
                            :items="contractors"
                            item-value="id"
                            item-text="name"
                            label="Εργολάβος"
                            clearable
                            outlined
                            class="filter-field client"
                            @change="onContractorSelect"
                        ></v-select>
                    </div>
                    <div class="search-button-wrapper">
                        <v-btn class="mx-2 white--text" medium color="black" @click="getCounts">
                            <v-icon medium class="bulding-id-icon">mdi-filter</v-icon> Αναζητηση
                        </v-btn>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <div class="cards">
            <v-card
                v-for="status of statuses"
                :key="status.name"
                class="mx-auto mb-3 card"
                :color="status.color"
                max-width="344"
                min-width="344"
                outlined
                elevation="6"
            >
                <v-list-item  three-line>
                    <v-icon x-large class="pr-3" color="white">{{ status.icon }}</v-icon>
                    <v-list-item-content>
                        <v-list-item-title class="text-h5 mb-1 content">
                            <span class="card-text">{{ status.name }}</span>
                            <span class="card-value">{{ assignmentsCountMap.get(status.value) }}</span>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-card>
        </div>
    </v-container>
</template>
<script>
    import stats from '@/services/stats'
    import client from '@/services/client'

    export default {
        computed: {
            theming() {
                return this.$store.getters.getTheming || {}
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            statuses() {
                return this.config?.assignmentStatuses || []
            }
        },
        data() {
            return {
                assignmentsCountMap: new Map(),
                panel: undefined,
                filter: {
                    contractorId: null,
                    clientId: null
                },
                clients: [],
                contractors: []
            }
        },
        created() {
            this.getCounts()
            this.getAllClients()
        },
        methods: {
            getAllClients() {
                client.getAllClients().then(resp => {
                    this.clients = resp.data
                    if (this.clients.length === 1) {
                        this.filter.clientId = this.clients[0].id
                        this.contractors = this.clients[0].contractors
                    }
                })
            },
            togglePanel() {
                const curr = this.panel
                this.panel = curr === undefined ? 0 : undefined
            },
            onClientSelect(clientId) {
                const selectedClient = this.clients.find(client => client.id === clientId)
                if (selectedClient) {
                    this.contractors = selectedClient.contractors
                }
            },
            onContractorSelect(contractorId) {
                this.filter.contractorId = contractorId
            },
            getCounts() {
                this.assignmentsCountMap = new Map()
                this.statuses.forEach(status => this.assignmentsCountMap.set(status.value, 0))
                stats.getAssignmentStatusCount(this.filter).then(resp => {
                    resp.data.forEach(element => {
                        this.assignmentsCountMap.set(element.status, element.count)
                    })
                    this.assignmentsCountMap = new Map(this.assignmentsCountMap)
                })
            }
        }
    }
</script>
<style scoped>
.container {
    widows: 85%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 3%;
}

.v-expansion-panel {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.filters {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}

.filter-field {
    padding: 0.8rem;
}

.filter-field.client {
    max-width: 250px;
}
.search-button-wrapper {
    display: flex;
    justify-content: center;
}
.card-title {
    font-weight: 500;
    font-size: 1.4rem;
}
.cards {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 3%;
}

.card-text {
    color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.content {
    display: flex;
    flex-direction: column;
}
.card-value {
    color: white;
    font-size: 2rem;
    font-weight: 1000;
}
.header {
    font-weight: 600;
}

.client-name {
    font-weight: 400;
}

.v-list-item--three-line .v-list-item__content {
    align-self: center !important;
}

.client-card-value {
    font-weight: 800;
    font-size: 1rem;
}
.expansion-panel {
    max-width: 90%;
    margin: 0 auto;
}

@media only screen and (max-width: 540px) {
    .expansion-panel {
        max-width: 100%;
    }
}
.v-expansion-panel {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}
</style>
